import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import handlePaginationString from 'src/app/helpers/pagination';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit, OnChanges {
  @Input() currentPage: number;
  @Input() pageCount: number;
  @Input() atFirstPage: boolean;
  @Input() atLastPage: boolean;
  @Input() blockButton = false;
  @Input() pageSize: number;
  @Input() pageSizeOptions: number[] = [];
  @Output() nextPage = new EventEmitter();
  @Output() previousPage = new EventEmitter();
  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();

  currentPageControl = new FormControl();

  getPaginationString = handlePaginationString;

  constructor() {   
  }

  ngOnInit(): void {
    this.currentPageControl.setValue(this.currentPage || 1);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['currentPage'] && !changes['currentPage'].firstChange) {
      this.currentPageControl.setValue(this.currentPage, { emitEvent: false });
    }
  }

  onPageInputBlur() {
    const value = this.currentPageControl.value;
    let page = value;
    if (value < 1) {
      page = 1;
    } else if (value > this.pageCount) {
      page = this.pageCount;
    }
    this.currentPageControl.setValue(page, { emitEvent: false });
    this.pageChange.emit(page);
  }

  getPreviousPage() {
    this.previousPage.emit(true);
  }

  getNextPage() {
    this.nextPage.emit(true);
  }

  onPageChange(page: number) {
    if (page >= 1 && page <= this.pageCount) {
      this.pageChange.emit(page);
    }
  }

  onPageSizeChange(size: number) {
    this.pageSizeChange.emit(size);
  }

  getPageNumbers(): number[] {
    return Array.from({ length: this.pageCount }, (_, i) => i + 1);
  }
}
